// @flow

export const TRACKING_EVENTS = {
  PAGE_VIEWED: 'page_viewed',
  PRODUCT_VIEWED: 'product_viewed',
  PRODUCT_LIST_VIEWED: 'product_list_viewed',
  PRODUCT_CART_ADDED: 'product_cart_added',
  PRODUCT_CART_REMOVED: 'product_cart_removed',
  CART_VIEWED: 'cart_viewed',
  CHECKOUT_STARTED: 'checkout_started',
  PURCHASE_COMPLETED: 'purchase_completed',
  PRODUCT_WISHLIST_ADDED: 'product_wishlist_added',
  CHAT_WIDGET_OPENED: 'chat_widget_opened',
};



// WEBPACK FOOTER //
// ./src/lib/tracking/events.js